// Navigation Component
import { navigateTo } from '../app';
import gsap from 'gsap';

export function renderNavigation(appState) {
  const nav = document.createElement('nav');
  nav.className = 'navbar';
  nav.style.cssText = `
    background: var(--color-bg-card);
    border-bottom: var(--border-width) solid var(--color-primary);
    padding: var(--spacing-lg) var(--spacing-xl);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    position: sticky;
    top: 0;
    z-index: var(--z-elevated);
  `;

  nav.innerHTML = `
    <div class="container flex justify-between items-center">
      <div class="nav-brand">
        <h1 class="text-gradient" style="font-size: var(--font-size-2xl); margin: 0; cursor: pointer; font-family: var(--font-display);">
          ⚡ STEM QUEST
        </h1>
      </div>
      
      <div class="nav-menu flex gap-md items-center">
        <button class="nav-link ${(!localStorage.getItem('currentView') || localStorage.getItem('currentView') === 'dashboard') ? 'active' : ''}" data-view="dashboard">Dashboard</button>
        <button class="nav-link ${localStorage.getItem('currentView') === 'quests' ? 'active' : ''}" data-view="quests">Quests</button>
        <button class="nav-link ${localStorage.getItem('currentView') === 'leaderboard' ? 'active' : ''}" data-view="leaderboard">Leaderboard</button>
        <button class="nav-link ${localStorage.getItem('currentView') === 'career' ? 'active' : ''}" data-view="career">Career</button>
        
        <div class="nav-user flex items-center gap-sm" style="margin-left: var(--spacing-lg);">
          <div class="user-avatar" data-view="profile" style="cursor: pointer;">
            <div style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: var(--gradient-primary);
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              border: 2px solid var(--color-primary);
            ">${(appState.user?.name || appState.user?.username || 'U').charAt(0).toUpperCase()}</div>
          </div>
          <div class="user-xp flex flex-col" style="font-size: var(--font-size-sm);">
            <div style="font-weight: 700; color: var(--color-primary);">
              Lvl ${appState.user?.progress?.level || appState.user?.level || 1}
            </div>
            <div style="color: var(--color-text-muted); font-size: var(--font-size-xs);">
              ${appState.user?.progress?.xp || appState.user?.totalXP || 0} XP
            </div>
          </div>
          <button id="logout-btn" class="btn btn-secondary btn-small" style="margin-left: var(--spacing-sm);">
            Logout
          </button>
        </div>
      </div>
    </div>
  `;

  // Add click handlers
  nav.querySelectorAll('[data-view]').forEach(button => {
    button.addEventListener('click', (e) => {
      // ... existing nav logic ...
      const view = e.currentTarget.getAttribute('data-view');

      // Update active state
      nav.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
      });
      if (button.classList.contains('nav-link')) {
        button.classList.add('active');
      }

      // Navigate directly without animation
      navigateTo(view, appState);
    });
  });

  // Logout handler
  setTimeout(() => {
    const logoutBtn = nav.querySelector('#logout-btn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', async () => {
        if (confirm('Are you sure you want to logout?')) {
          if (appState.useBackend) {
            const { authAPI } = await import('../services/api');
            authAPI.logout();
          } else {
            localStorage.removeItem('stem-quest-user');
            localStorage.removeItem('currentView');
            window.location.reload();
          }
        }
      });
    }
  }, 0);



  // Style nav links
  const style = document.createElement('style');
  style.textContent = `
    .nav-link {
      background: transparent;
      border: 2px solid transparent;
      color: var(--color-text-secondary);
      padding: var(--spacing-sm) var(--spacing-md);
      font-weight: 600;
      cursor: pointer;
      transition: all var(--transition-fast);
      font-family: var(--font-primary);
      font-size: var(--font-size-base);
    }
    
    .nav-link:hover {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }
    
    .nav-link.active {
      color: var(--color-primary);
      border-color: var(--color-primary);
      box-shadow: 3px 3px 0 var(--color-primary);
    }
    
    @media (max-width: 768px) {
      .nav-menu {
        display: none;
      }
    }
  `;
  document.head.appendChild(style);

  return nav;
}
